import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

import { environment } from '../environments/environment';
import { MaterialModule } from './material';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './pages/shell/shell.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { EmployeeDialogComponent } from './pages/employees/employee-dialog.component';
import { LedgerDialogComponent } from './pages/employees/ledger-dialog.component';
import { PurchasesComponent } from './pages/purchases/purchases.component';
import { CateringComponent } from './pages/catering/catering.component';
import { HelpComponent } from './pages/help/help.component';
import { ConfirmDialogComponent } from './core/confirm-dialog.component';
import { WelcomeDialogComponent } from './core/welcome-dialog.component';
import { TranslatePipe } from './core/translate.pipe';

// Note there is no AngularFirestore import here, and there should not be one.
// The portal reads and writes exclusively through the /portal cloud API, which
// enforces per-customer scoping; the project's Firestore rules are permissive
// enough that direct client access would expose every customer's employees.
// See PORTAL.md.
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ShellComponent,
    OverviewComponent,
    EmployeesComponent,
    EmployeeDialogComponent,
    LedgerDialogComponent,
    PurchasesComponent,
    CateringComponent,
    HelpComponent,
    ConfirmDialogComponent,
    WelcomeDialogComponent,
    TranslatePipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
